import type { MemberAssignedRating } from "../../types";
import { compareSortValues, type GridSort, type GridSortValue } from "../gridSort";

/** Feedback 5.2: the grid opens sorted by condition name, then rating text; synthetic rows sit under their condition. */
export const DEFAULT_SORT: GridSort = { key: "condition", direction: "asc" };

/** Whatever column is sorted, ties break on condition name then rating text so the order is stable and readable. */
export function sortByColumnThenConditionAndRating(rows: readonly MemberAssignedRating[], sort: GridSort, sortValue: (row: MemberAssignedRating) => GridSortValue): MemberAssignedRating[] {
  const factor = sort.direction === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => compareSortValues(sortValue(a), sortValue(b)) * factor || compareSortValues(a.conditionName, b.conditionName) || compareSortValues(a.ratingText, b.ratingText));
}
